import React from 'react';

const SvgDe = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="DE_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path id="DE_svg__d" d="M0 6.667h28v6.667H0z" />
      <filter
        x="-5.4%"
        y="-22.5%"
        width="110.7%"
        height="145%"
        filterUnits="objectBoundingBox"
        id="DE_svg__c"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
      <path id="DE_svg__f" d="M0 13.333h28V20H0z" />
      <filter
        x="-5.4%"
        y="-22.5%"
        width="110.7%"
        height="145%"
        filterUnits="objectBoundingBox"
        id="DE_svg__e"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="DE_svg__b" fill="#fff">
        <use xlinkHref="#DE_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#DE_svg__a" />
      <path fill="#262626" mask="url(#DE_svg__b)" d="M0 0h28v6.667H0z" />
      <g mask="url(#DE_svg__b)">
        <use fill="#000" filter="url(#DE_svg__c)" xlinkHref="#DE_svg__d" />
        <use fill="#F01515" xlinkHref="#DE_svg__d" />
      </g>
      <g mask="url(#DE_svg__b)">
        <use fill="#000" filter="url(#DE_svg__e)" xlinkHref="#DE_svg__f" />
        <use fill="#FFD521" xlinkHref="#DE_svg__f" />
      </g>
    </g>
  </svg>
);

export default SvgDe;
